import { useTranslation } from "react-i18next"

import LogoPng from "@/assets/imgs/logo-1.png"

import { ANCHORS, DOWNLOAD_PAGE_URL, SITE } from "../site-config"
import { CONTAINER } from "./styles"
import { TelegramIcon } from "./TelegramIcon"

/** 页脚：政策 / 产品导航 + 公司信息 + 版权 */
export function SiteFooter() {
  const { t } = useTranslation()

  const policies = [
    { href: `#${ANCHORS.refund}`, label: t("official_nav_refund") },
    { href: `#${ANCHORS.dispute}`, label: t("official_refund_dispute_title") },
    { href: `#${ANCHORS.terms}`, label: t("official_nav_terms") },
    { href: `#${ANCHORS.privacy}`, label: t("official_terms_privacy_title") },
    { href: `#${ANCHORS.thirdParty}`, label: t("official_terms_third_title") },
  ]

  const products = [
    { href: `#${ANCHORS.model}`, label: t("official_nav_model") },
    // { href: `#${ANCHORS.payment}`, label: t("official_nav_payment") },
    { href: `#${ANCHORS.faq}`, label: t("official_nav_faq") },
    { href: `#${ANCHORS.contact}`, label: t("official_nav_contact") },
    { href: DOWNLOAD_PAGE_URL, label: t("official_cta_download") },
  ]

  const linkClass = "text-white/70 transition-colors hover:text-white"

  return (
    <footer className="bg-[#01B0FE] pt-12 text-[14.5px] text-white/70">
      <div
        className={`${CONTAINER} grid gap-8 lg:grid-cols-[1.4fr_0.8fr_0.8fr_1.2fr]`}
      >
        <div className="flex flex-wrap items-center gap-2.5">
          <img src={LogoPng} alt="" className="w-[36px] h-[36px]" />
          <span className="text-[19px] font-extrabold text-white">
            henghengmall
          </span>
          <p className="mt-1.5 w-full">{t("official_footer_slogan")}</p>
        </div>

        <nav className="flex flex-col gap-2">
          <h4 className="mb-1.5 text-sm uppercase tracking-[0.04em] text-white">
            {t("official_footer_policy_title")}
          </h4>
          {policies.map((item) => (
            <a key={item.label} href={item.href} className={linkClass}>
              {item.label}
            </a>
          ))}
        </nav>

        <nav className="flex flex-col gap-2">
          <h4 className="mb-1.5 text-sm uppercase tracking-[0.04em] text-white">
            {t("official_footer_product_title")}
          </h4>
          {products.map((item) => (
            <a key={item.label} href={item.href} className={linkClass}>
              {item.label}
            </a>
          ))}
        </nav>

        <div className="min-w-0">
          <h4 className="mb-1.5 text-sm uppercase tracking-[0.04em] text-white">
            {t("official_footer_company_title")}
          </h4>
          <p className="m-0 mb-3 break-words text-white">{SITE.companyName}</p>
          <p className="m-0 mb-1.5">{t("official_contact_kv_support")}</p>
          <a
            href={SITE.supportOnlineUrl}
            className={`${linkClass} inline-flex items-center gap-1.5`}
          >
            <TelegramIcon />
            {SITE.supportOnline}
          </a>
          <p className="m-0 mb-1.5 mt-3">
            {t("official_contact_kv_company_phone")}
          </p>
          <p className="m-0">{SITE.companyPhone}</p>
        </div>
      </div>

      <div className="mt-9 border-t border-white/10 py-6">
        <div
          className={`${CONTAINER} flex flex-col items-center gap-2 text-center`}
        >
          <small className="m-0 text-sm text-white">
            {t("official_footer_copyright", {
              year: new Date().getFullYear(),
              company: SITE.companyName,
            })}
          </small>
          <small className="m-0 text-white/70">
            {t("official_footer_updated", {
              company: SITE.companyName,
              date: SITE.effectiveDate,
            })}
          </small>
        </div>
      </div>
    </footer>
  )
}
